import * as echarts from "echarts"
import { ECBasicOption } from "echarts/types/dist/shared"
import { OptionDataValue } from "echarts/types/src/util/types"
import { UIView } from "uicore-ts"


export class EChartsView extends UIView {
    
    chart = echarts.init(this.viewHTMLElement, null, {
        renderer: "svg", // canvas rendering mode
        devicePixelRatio: window.devicePixelRatio || 1,
        // @ts-ignore
        pointerCapture: false
    })
    
    private _showTooltipEvent?: {
        type: "showtip";
        dataIndexInside: number;
        dataIndex: number;
        seriesIndex: number;
        from: string
    }
    
    constructor(elementID?: string) {
        
        super(elementID)
        
        // Code for further setup if necessary
        
        this.controlEventTargetAccumulator.PointerUp = (sender, event) => {
            
            this.chart.getZr().handler.dispatch('mouseup', event);
            
        }
        
        // This hack is needed because echarts adds the tooltip into the canvas element, which does not work.
        this.chart.on(
            "showTip",
            (event: {
                type: "showtip",
                dataIndexInside: number,
                dataIndex: number,
                seriesIndex: number,
                from: string
            }) => {
                
                this._showTooltipEvent = event
                
                const tooltipEl = document.querySelector(".EChartsView_chart_tooltip") as HTMLElement
                if (tooltipEl && tooltipEl.parentElement != this.viewHTMLElement) {
                    this.viewHTMLElement.appendChild(tooltipEl)
                }
            }
        )
        
        
    }
    
    
    // Override this to format The value, do not use the built-in valueFormatter in the dataOptions as that is not good
    formatTooltipValue(value: any, showTooltipEvent: {
        type: "showtip";
        dataIndexInside: number;
        dataIndex: number;
        seriesIndex: number;
        from: string
    }) {
        
        // noinspection BadExpressionStatementJS
        showTooltipEvent
        
        return value
        
    }
    
    
    set dataAndConfiguration(dataOptions: ECBasicOption | { tooltip: { cb_valueFormatter: (
                value: any,
                showTooltipEvent: {
                    type: "showtip",
                    dataIndexInside: number,
                    dataIndex: number,
                    seriesIndex: number,
                    from: string
                }
            ) => any } } ) {
        
        
        dataOptions = ({
            tooltip: {
                trigger: "item",
                appendToBody: false,
                transitionDuration: 0,
                className: "EChartsView_chart_tooltip",
                valueFormatter: (
                    value: OptionDataValue | OptionDataValue[],
                    dataIndex: number
                ) => {
                    
                    // @ts-ignore
                    return ((dataOptions?.tooltip?.cb_valueFormatter as (
                        value: any,
                        showTooltipEvent: {
                            type: "showtip",
                            dataIndexInside: number,
                            dataIndex: number,
                            seriesIndex: number,
                            from: string
                        }
                    ) => any) ?? this.formatTooltipValue)(value, this._showTooltipEvent!)
                    
                }
            }
        } satisfies ECBasicOption).objectByCopyingValuesRecursivelyFromObject(dataOptions)
        
        this.chart.setOption(dataOptions)
        
    }
    
    get dataAndConfiguration() {
        return this.chart.getOption()
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding
        
        const bounds = this.bounds.rectangleWithInset(padding)
        
        this.chart.resize({ height: bounds.height, width: bounds.width })
        
        
    }
    
    
}




























